<h2 mat-dialog-title>{{ 'activity_search.panel_title' | translate }}</h2>
<mat-dialog-content #dialogContent>
    <app-activity-selection-actions
        [selectedCount]="selectedActivityCount"
        (clearSelection)="clearSelection()"
        (validateSelection)="close()">
    </app-activity-selection-actions>

    <app-mathia-lessons-search-filter
        (selectionChange)="onSelectionChange($event)">
    </app-mathia-lessons-search-filter>

    @if (isLoading && activities.length === 0) {
        <mat-spinner diameter="32"></mat-spinner>
    }

    @if (activities.length > 0) {
        <div class="mathia-activity-search-dialog__results">
            @for (activity of activities; track activity.id) {
                <button
                    mat-button
                    type="button"
                    [class.selected]="isSelected(activity.id)"
                    (click)="toggleActivity(activity.id)">
                    {{ activity.get('title') || activity.get('metadatas')?.title || activity.id }}
                </button>
            }
        </div>
    }

    @if (isLoading && activities.length > 0) {
        <mat-spinner diameter="32"></mat-spinner>
    }

    @if (!isLoading && activities.length === 0 && !hasLoadError) {
        {{ 'activity_search.no_lessons_found' | translate }}
    }

    @if (hasLoadError) {
        <button mat-button type="button" (click)="retryLoading()">
            {{ 'generic.retry' | translate }}
        </button>
    }

    @if (hasNextPage) {
        <div #resultsSentinel aria-hidden="true"></div>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button type="button" mat-dialog-close>{{ 'generic.cancel' | translate }}</button>
</mat-dialog-actions>
